import React, { useContext, useLayoutEffect, useState } from "react";
import { Card } from "./card";
import { cn } from "../../lib/helpers";
import { CardContext } from "./context";
import { SiteContext } from "../global/site-context";
import { Button } from "../button";
import { ArrowLeft } from "../icon/arrow-left";
import { SectionContext } from "../sections/context";
import { AdminLink } from "../global/layout";

// referenced by index number, no map
const columnClasses = [
  "",
  "",
  "sm:grid-cols-2",
  "md:grid-cols-2 xl:grid-cols-3",
  "sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4",
  "md:grid-cols-3 lg:grid-cols-5",
];

export const CardGrid = ({
  title,
  nodes,
  browseMoreHref,
  browseMoreText,
  showSummary,
  allowSummary,
  showByline,
  hideLabels,
  hideDate,
  showSubTags,
  hideTitles,
  minimal,
  maxColumns,
  hideMore,
  cta,
  panels,
  makeThumbnail,
  showExtended,
  attribution,
  hideType,
  bonusCard,
  cardClasses,
  isMasonry,
  showAllImages,
  // only effect stories
  showIntegrations,
}) => {
  // avoids useState + useEffect to ensure SSR
  const site = useContext(SiteContext);
  const section = useContext(SectionContext);
  const [isAdmin, setIsAdmin] = useState(site.isAdmin);

  const colCount = maxColumns
    ? maxColumns
    : nodes.length < 4
      ? nodes.length
      : null;

  useLayoutEffect(() => {
    setIsAdmin(site.isAdmin);
  }, []);

  return (
    <>
      {title && <h2 className="mb-6 text-sm uppercase">{title}</h2>}
      <ul
        className={cn(
          "grid",
          minimal
            ? "gap-8"
            : maxColumns === 2 && !panels
              ? "gap-12"
              : panels
                ? "gap-4"
                : "gap-3 gap-y-12",
          columnClasses[colCount]
        )}
        data-swiftype-index="false"
      >
        {nodes &&
          nodes.map((node, index) => {
            const suggestionAdded = // one before the third slot
              (maxColumns === 3 && index === 1) ||
              // one before the fourth slot
              (maxColumns === 2 && index === 0);

            return (
              <React.Fragment key={index}>
                <li className="relative">
                  {node && (
                    <CardContext.Provider
                      value={{
                        ...node,
                        showSummary,
                        showByline,
                        cta: node.cta || cta,
                        maxColumns: colCount,
                        showIntegrations,
                        hideLabels,
                        showSubTags,
                        showExtended,
                        minimal,
                        allowSummary,
                        gated: node.formId,
                        makeThumbnail,
                        hideTitles,
                        hideDate,
                        attribution,
                        hideType,
                        showAllImages,
                        highlighted: node.highlighted,
                        // @todo determine in gatsby-node
                        isMasonry,
                        isVideo:
                          node._type === "video" ||
                          node.videoId ||
                          node.mainVideo?.url ||
                          node?.categories?.find(
                            (c) =>
                              c._id === "d5c00b46-ae0d-459b-9071-93fa77309428"
                          ),
                      }}
                    >
                      <Card className={cardClasses} />

                      {isAdmin && <AdminLink doc={node} />}
                    </CardContext.Provider>
                  )}
                </li>

                {bonusCard &&
                  index === bonusCard.position &&
                  bonusCard.component}
              </React.Fragment>
            );
          })}
      </ul>
      {!hideMore && browseMoreHref && (
        <div className="mt-8">
          <Button
            href={browseMoreHref}
            text={browseMoreText || site.token("seeAllPosts")}
            bgColor={section.isDarkBg ? "bg-light-10" : "bg-dark-5"}
            className={section.isDarkBg ? "" : "text-secondary"}
            icon={<ArrowLeft size={12} />}
          // isSmall={true}
          />
        </div>
      )}
    </>
  );
};
